"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

type Props = {
  children: React.ReactNode;
  adminOnly?: boolean;
};

export default function AuthGuard({
  children,
  adminOnly = false,
}: Props) {
  const router = useRouter();

  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (!token) {
      router.push("/login");
      return;
    }

    if (adminOnly && role !== "admin") {
      router.push("/");
      return;
    }

    setAllowed(true);
  }, [router, adminOnly]);

  if (!allowed) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-slate-100">
        <div className="text-slate-500">
          Betöltés...
        </div>
      </main>
    );
  }

  return <>{children}</>;
}
